
































































































































import PrefixItem from "@/components/PrefixItem.vue";
import PrefixesAdd from "@/components/PrefixesAdd.vue";
import HeadingButtons from "@/components/HeadingButtons.vue";
import HeadingInline from "@/components/HeadingInline.vue";
import PrefixesOverallStats from "@/components/PrefixesOverallStats.vue";
import PrefixesAddToggle from "@/components/PrefixesAddToggle.vue";
import { getMetricLabel } from "@/utils/chart";
import {
  PREFIX_HIT_RATE_LABEL,
  HELP_PREFIX_FRACTION_REQUESTS,
  HELP_PREFIX_FRACTION_ITEMS,
  HELP_PREFIX_FRACTION_MEMORY,
} from "@/config/series";
import { PREVIEW_PREFIXES } from "@/config/preview";
import { Prefix } from "@/types/debug-mode";
import GetProcessedStats from "@/mixins/get-processed-stats";
import { Component, Mixins } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  components: {
    PrefixItem,
    PrefixesAdd,
    HeadingButtons,
    HeadingInline,
    PrefixesOverallStats,
    PrefixesAddToggle,
  },
})
export default class PrefixesView extends Mixins(GetProcessedStats) {
  created() {
    // Simple caching
    // The more elaborate `fetch, fetching, fetched...` strategy is overkill here
    if (!this.prefixes) {
      this.$store.dispatch("debugMode/fetchPrefixes");
    }

    // For overall hit rate
    this.getProcessedStats();
  }

  beforeDestroy() {
    // Refetch data clean up
    this.cleanUpProcessedStats();
  }

  @State(state => state.debugMode.prefixes) prefixes!: Prefix[] | null;
  @State(state => state.debugMode.showAddPrefix) showAddPrefix!: boolean;

  hitRateLabel = PREFIX_HIT_RATE_LABEL;

  helpPrefixFractionRequests = HELP_PREFIX_FRACTION_REQUESTS;

  helpPrefixFractionItems = HELP_PREFIX_FRACTION_ITEMS;

  helpPrefixFractionMemory = HELP_PREFIX_FRACTION_MEMORY;

  get prefixLimit() {
    return this.features["prefix-limit"] as number;
  }

  get canAddPrefixes() {
    return this.prefixLimit > 0 && !this.prefixLimitReached;
  }

  get previewPrefixes() {
    return PREVIEW_PREFIXES;
  }

  get prefixLimitReached() {
    return this.prefixes && this.prefixes.length >= this.prefixLimit;
  }

  get showFirstPrefixCard() {
    // if the Add Prefix form card is hidden
    // and prefixes have been fetched, but there are zero prefixes
    // and prefixes can be added, then show.
    return !this.showAddPrefix && this.prefixes && this.prefixes.length === 0 && this.canAddPrefixes;
  }

  get prefixUsage() {
    const prefixLen = this.prefixes ? this.prefixes.length : 0;
    return `${prefixLen}/${this.prefixLimit}`;
  }

  toggleAddPrefix() {
    const toggle = this.showAddPrefix ? "Hide" : "Show";
    this.$ga.toggle(`${toggle} add prefix`);
    this.$store.dispatch("debugMode/setShowAddPrefix", !this.showAddPrefix);
  }

  metricLabel(metricID: string): string {
    return getMetricLabel(metricID);
  }
}
